import _get from 'lodash/get';
import { formatPartName } from '@tekion/tekion-base/formatters/parts/general';
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
var getPartOptionLabel = function getPartOptionLabel() {
  var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  var part = _get(option, 'data.part', EMPTY_OBJECT);
  return formatPartName(part);
};
var getPartOptionValue = function getPartOptionValue(option) {
  return option.id;
};
var PART_OPTION_CONFIG = {
  getOptionLabel: getPartOptionLabel,
  getOptionValue: getPartOptionValue
};
export default PART_OPTION_CONFIG;